import { render, staticRenderFns } from "./list_subcategories_marketplace_component.vue?vue&type=template&id=5614e516&scoped=true"
import script from "./list_subcategories_marketplace_component.vue?vue&type=script&lang=js"
export * from "./list_subcategories_marketplace_component.vue?vue&type=script&lang=js"
import style0 from "./list_subcategories_marketplace_component.vue?vue&type=style&index=0&id=5614e516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5614e516",
  null
  
)

export default component.exports